'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { FormFeedback, Input, Label } from 'reactstrap';
import { Dictionaries } from '../../../i18n/i18n-config';
import { getI18nUtils } from '../../../i18n/i18n-utils';

interface FormikSelectInputProps {
  name: string;
  id?: string;
  formik: any;
  required?: boolean;
  options: { label: string; value: string }[];
  intlKey?: string;
  className?: string;
  withoutLabel?: boolean;
  dictionary: Partial<Dictionaries>;
}

function FormikSelectInput({
  name,
  id,
  required,
  intlKey,
  formik,
  options,
  className,
  withoutLabel,
  dictionary,
}: FormikSelectInputProps): JSX.Element {
  const { formatMessage } = getI18nUtils(dictionary);
  const emptyLabelIncluded = options.find(({ label }) => label === '');
  const { touched, error, value } = formik.getFieldMeta(name);
  const { onBlur, onChange } = formik.getFieldProps(`${name}`);

  return (
    <div className={className || ''}>
      {!withoutLabel && (
        <Label for={name} className={required ? 'required' : ''}>
          {formatMessage({ id: intlKey || name })}
        </Label>
      )}
      <Input
        invalid={touched && error}
        type="select"
        name={name}
        id={id || name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      >
        {!emptyLabelIncluded && (
          <option value="" disabled className="text-light">
            {/* {formatMessage({ id: 'select-option' })} */}
            ---
          </option>
        )}
        {options.map(({ label, value: optionValue }, i) => (
          <option key={`${name}_option_${i}`} value={optionValue}>
            {label}
          </option>
        ))}
      </Input>
      {error && <FormFeedback>{formatMessage({ id: error })}</FormFeedback>}
    </div>
  );
}

export default FormikSelectInput;
